import { axiosConfig } from './axios-config.js'

export const contactInfo = {
  // 取得聯絡資訊
  get: (token) => axiosConfig.get('/api/console/contact', token),

  // 更新聯絡資訊
  update: (data, token) => axiosConfig.post('/api/console/contact', data, token)
}
